"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.schema = void 0;

var firebase = _interopRequireWildcard(require("firebase/app"));

var _models = require("@knxlab/models");

var _Schemas = require("./Schemas");

var _Bloc = _interopRequireWildcard(require("./TrainingSession/Bloc"));

var _BlocExercice = _interopRequireDefault(require("./TrainingSession/BlocExercice"));

var _Exercice = _interopRequireDefault(require("./Exercice"));

var _Equipement = _interopRequireDefault(require("./Equipement"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fakeData = [{
  id: "123",
  title: "Ma premi\xE8re s\xE9ance de yoga",
  type: "exercices",
  description: "TESt de description",
  level: 1,
  sports: ["crosstraining", "musculation"],
  video: {
    height: 800,
    ref: "medias/videos/c7851690-546d-4569-8ffb-29e91cb5ac45",
    type: "video/mp4",
    width: 640
  },
  image: {
    ref: "images/0425be7c-dcf2-42c6-8f6c-58dc89fbcffa.jpg"
  },
  blocs: [{
    title: "Echauffement",
    description: "Echauffement - allez y doucement !",
    volume: 10,
    video: {
      ref: "images/DJI_0004.MP4"
    },
    image: {
      ref: "images/0425be7c-dcf2-42c6-8f6c-58dc89fbcffa.jpg"
    },
    exercices: [{
      id: "test",
      type: "rest",
      timer: 5
    }]
  }]
}, {
  id: "12",
  title: "Ma premi\xE8re s\xE9ance de yoga",
  type: "video",
  description: "TESt de description",
  level: 1,
  video: {
    ref: "images/DJI_0004.MP4"
  },
  image: {
    ref: "images/0425be7c-dcf2-42c6-8f6c-58dc89fbcffa.jpg"
  }
}, {
  id: "1",
  title: "Pec Workout Day 1",
  type: "exercices",
  description: "Un entrainement pour developper les pecs sur la dur\xE9e",
  level: 3,
  video: {
    ref: "images/DJI_0004.MP4"
  },
  image: {
    ref: "images/0425be7c-dcf2-42c6-8f6c-58dc89fbcffa.jpg"
  },
  blocs: [{
    title: "Echauffement",
    description: "Echauffement - allez y doucement !",
    volume: 10,
    video: {
      ref: "images/DJI_0004.MP4"
    },
    image: {
      ref: "images/0425be7c-dcf2-42c6-8f6c-58dc89fbcffa.jpg"
    },
    exercices: [{
      id: "test",
      type: "reps",
      __list__types: ["reps", "timer"],
      reps: 10,
      exercice: {
        title: "Kettlebell Squat",
        description: "Un exercice n\xE9cessitant beaucoup de technique",
        tags: ["crosstraining", "musculation"],
        level: 2,
        equipment: ["barbell"],
        mainMuscleGroup: ["upper_legs"],
        otherMuscleGroup: ["lower_legs"]
      }
    }, {
      id: "test-pompes",
      type: "timer",
      __list__types: ["reps", "timer"],
      timer: 120,
      exercice: {
        title: "Pompes",
        description: "Un exercice n\xE9cessitant beaucoup de technique",
        tags: ["crosstraining", "musculation"],
        level: 2,
        equipment: ["barbell"],
        mainMuscleGroup: ["upper_legs"],
        otherMuscleGroup: ["lower_legs"]
      }
    }, {
      id: "test-abdos",
      type: "timer",
      __list__types: ["reps", "timer"],
      exercice: {
        title: "Abdos",
        description: "Un exercice n\xE9cessitant beaucoup de technique",
        tags: ["crosstraining", "musculation"],
        level: 2,
        equipment: ["barbell"],
        mainMuscleGroup: ["upper_legs"],
        otherMuscleGroup: ["lower_legs"]
      }
    }, {
      id: "test",
      type: "rest",
      timer: 5
    }]
  }]
}];
var schema = {
  id: "/TrainingSession",
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    owner: {
      type: "string"
    },
    title: {
      type: "string"
    },
    type: {
      type: "string",
      "enum": ["video", "exercices"]
    },
    description: {
      type: "string"
    },
    level: _Schemas.level,
    sports: {
      type: "array",
      items: {
        type: "string"
      }
    },
    image: _Schemas.imageVideoMedia,
    video: _Schemas.imageVideoMedia,
    blocs: {
      type: "array",
      items: {
        "$ref": _Bloc.schemaId
      }
    }
  }
};
exports.schema = schema;
var NAME = "TrainingSession";

var TrainingSession = /*#__PURE__*/function (_AbstractObject) {
  _inherits(TrainingSession, _AbstractObject);

  var _super = _createSuper(TrainingSession);

  function TrainingSession() {
    _classCallCheck(this, TrainingSession);

    return _super.apply(this, arguments);
  }

  _createClass(TrainingSession, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var db, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.owner) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Does not have an owner!");

              case 2:
                db = firebase.firestore();

                if (!this.id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return db.collection("trainingsessions").doc(this.id).set(this["export"]());

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.next = 10;
                return db.collection("trainingsessions").add(this["export"]());

              case 10:
                result = _context.sent;
                this.id = result.id;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }() // @TODO Remove that

  }, {
    key: "getEquipements",
    value: function getEquipements() {
      var exercices = this.getUniqueListOfExercices();
      var equipements = {};
      exercices.forEach(function (exercice) {
        if (!exercice.equipments) {
          return true;
        }

        exercice.equipments.forEach(function (eq) {
          equipements[eq] = true;
        });
      });
      return Object.keys(equipements).map(function (eq_id) {
        return _Equipement["default"].getById(eq_id);
      });
    } // @TODO replace by getFlattenBlocExercic

  }, {
    key: "getFlattenExercices",
    value: function getFlattenExercices() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeRest = _ref.includeRest,
          includeRest = _ref$includeRest === void 0 ? true : _ref$includeRest;

      var blocExercices = [];
      var lastExerciceIndex = 0;
      (this.blocs || []).forEach(function (bloc) {
        for (var count = 0; count < (bloc.volume || 1); count++) {
          var thisBlocExercices = bloc.exercices || [];

          for (var index = 0; index < thisBlocExercices.length; index++) {
            if (includeRest || !thisBlocExercices[index].isRest()) {
              if (!thisBlocExercices[index].isRest()) {
                lastExerciceIndex = blocExercices.length;
              }

              blocExercices.push(thisBlocExercices[index].clone(function (blocEx) {
                blocEx.setData({
                  bloc: {
                    title: bloc.title
                  }
                });
              }));
            }
          }
        }
      });
      return blocExercices.slice(0, lastExerciceIndex + 1);
    }
  }, {
    key: "getUniqueListOfExercices",
    value: function getUniqueListOfExercices() {
      var exercices = [];
      var alreadySeenId = {};
      (this.blocs || []).forEach(function (bloc) {
        for (var count = 0; count < (bloc.volume || 1); count++) {
          var thisBlocExercices = bloc.exercices || [];

          for (var index = 0; index < thisBlocExercices.length; index++) {
            if (thisBlocExercices[index].exercice) {
              var exercice = thisBlocExercices[index].exercice;

              if (!alreadySeenId[exercice.id]) {
                exercices.push(exercice);
                alreadySeenId[exercice.id] = true;
              }
            }
          }
        }
      });
      return exercices;
    }
  }, {
    key: "getBlocsExercicesChecksum",
    value: function getBlocsExercicesChecksum() {
      var checksum = [];
      (this.blocs || []).forEach(function (bloc) {
        checksum.push("|bloc:" + bloc.id + "|");
        bloc.exercices && bloc.exercices.forEach(function (blocExercice) {
          checksum.push(blocExercice.getChecksum());
        });
      });
      return checksum.join("_");
    }
  }, {
    key: "setData",
    value: function setData(data) {
      _get(_getPrototypeOf(TrainingSession.prototype), "setData", this).call(this, data);
    }
  }, {
    key: "getExecutionTime",
    value: function getExecutionTime() {
      return (this.blocs || []).map(function (bloc) {
        return bloc.getExecutionTime() * bloc.volume;
      }).reduce(function (previous, current) {
        return previous + current;
      }, 0);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (!this.hasBloc()) {
        return true;
      }

      for (var index = 0; index < this.blocs.length; index++) {
        var bloc = this.blocs[index];

        if (!bloc.isEmpty()) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "hasBloc",
    value: function hasBloc() {
      return !!this.blocs && !!this.blocs.length;
    }
  }, {
    key: "addBloc",
    value: function addBloc(bloc) {
      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.blocs || !this.blocs.length) {
        this.blocs = [];
      }

      if (first) {
        this.blocs = [bloc].concat(_toConsumableArray(this.blocs));
      } else {
        this.blocs.push(bloc);
      }
    }
  }, {
    key: "removeBloc",
    value: function removeBloc(blocIndex) {
      if (!this.blocs) {
        this.blocs = [];
      }

      this.blocs.splice(blocIndex, 1);
    }
  }, {
    key: "removeBlocExercice",
    value: function removeBlocExercice(blocIndex, atIndex) {
      this.blocs[blocIndex].exercices.splice(atIndex, 1);
    }
  }, {
    key: "addExercice",
    value: function addExercice(exercice, blocIndex, atIndex) {
      if (!this.blocs || !this.blocs[blocIndex]) {
        return false;
      }

      if (!this.blocs[blocIndex].exercices) {
        this.blocs[blocIndex].exercices = [];
      }

      this.blocs[blocIndex].exercices.splice(atIndex, 0, exercice);
    }
  }, {
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }, {
    key: "getImageRef",
    value: function getImageRef() {
      return this.image && this.image.ref || null;
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var db;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.id) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Cannot delete an object that does not exists yet");

              case 2:
                db = firebase.firestore();
                _context2.next = 5;
                return db.collection("trainingsessions").doc(this.id)["delete"]();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }], [{
    key: "get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref2) {
        var id, owner, db, trainingSessionData, trainingSession;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _ref2.id, owner = _ref2.owner;
                db = firebase.firestore();
                _context3.next = 4;
                return db.collection("trainingsessions").doc(id).get();

              case 4:
                trainingSessionData = _context3.sent;

                if (trainingSessionData.exists) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("does not exists");

              case 7:
                trainingSession = new TrainingSession();
                trainingSession.setData(trainingSessionData.data());
                trainingSession.id = trainingSessionData.id;
                return _context3.abrupt("return", trainingSession);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function get(_x) {
        return _get2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref3) {
        var owner, db, refCounter, countersRef, total, counters;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                owner = _ref3.owner;
                db = firebase.firestore();
                refCounter = db.collection("userscounter").doc(owner);
                _context4.next = 5;
                return refCounter.get();

              case 5:
                countersRef = _context4.sent;
                total = null;

                if (countersRef.exists) {
                  counters = countersRef.data();
                  total = counters.trainingsessions || null;
                }

                _context4.next = 10;
                return (0, _models.getListFromFirebaseRef)(db.collection("trainingsessions").where("owner", "==", owner), {
                  limit: 100
                }, function (doc) {
                  var trainingSession = new TrainingSession();
                  trainingSession.setData(doc.data());
                  trainingSession.id = doc.id;
                  return trainingSession;
                }, {
                  total: total
                });

              case 10:
                return _context4.abrupt("return", _context4.sent);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getAll(_x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getRandomData",
    value: function getRandomData() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var trainingSession = new TrainingSession();
      trainingSession.setData(fakeData[index > 0 && index < fakeData.length ? index : 0]);
      return trainingSession;
    }
  }]);

  return TrainingSession;
}(_models.AbstractObject);

exports["default"] = TrainingSession;
TrainingSession.register({
  name: NAME,
  schema: schema,
  __class: TrainingSession
});